declare global {
  interface Window {
    caReady: any[];
    cact: (...args: any[]) => void;
  }
}

export type TrackAddToCartOptions = {
  product_id: string;
  product_sku: string;
  product_quantity: number;
  product_variant: string;
  product_brand: string;
  product_name: string;
  product_category_1: string;
  product_category_2: string;
  product_category_3: string;
  product_unitprice_ati: number;
  product_unitprice_tf?: number;
};

const TrackAddToCart = (productOptions: TrackAddToCartOptions) => {
  const _window = window as any;
  const tC = _window.tC;

  tC?.event?.add_to_cart?.(
    {
      type: "add_to_cart",
      target: {},
    },
    {
      product_id: productOptions.product_id,
      product_sku: productOptions.product_sku,
      product_quantity: productOptions.product_quantity,
      product_variant: productOptions.product_variant,
      product_brand: productOptions.product_brand,
      product_name: productOptions.product_name,
      product_category_1: productOptions.product_category_1,
      product_category_2: productOptions.product_category_2,
      product_category_3: productOptions.product_category_3,
      product_unitprice_ati: productOptions.product_unitprice_ati,
      product_unitprice_tf: productOptions.product_unitprice_tf,
    }
  );
};

export default TrackAddToCart;
